import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../redux/store';
import { useNavigate, useParams } from 'react-router-dom';

import { Placeholder } from '../components/Placeholder';
import { LoungeHeader } from '../components/WdwLoungeHeader';
import { LoungeBox } from '../components/LoungeBox';
import { LoungeList } from '../components/LoungeList';
import { MobileLoungeHeader } from '../components/WdwMobileLoungeHeader';
import { PendingPostNotice } from '../components/PendingPostNotice';
import {
  fetchDisneyWorldLounges,
  fetchStickyLoungeWdw,
  fetchUserMenu,
} from '../redux/lounges/slice';
import {
  applyAssignMenuFlags,
  syncAssignMenuFlagsToCurrentUser,
} from '../utils/assignMenu';
// @ts-ignore
import { Helmet } from 'react-helmet-async';
import { selectLounges } from '../redux/lounges/selectors';
import {
  isFulfilledFeedAction,
  shouldShowFeedInitialLoading,
  shouldShowFeedLoadError,
} from '../utils/feedLoadError';
import { asArray } from '../utils/asArray';
import { usersSelector } from '../redux/users/selectors';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import { StickyPost } from '../components/StickyPostWdw';
import stickerImage from '../assets/img/stickers.jpg';

import { postLoungeWdw } from '../redux/lounges/slice';
// @ts-ignore
import { loadProgressBar } from 'axios-progress-bar';
import 'axios-progress-bar/dist/nprogress.css';
import { WDWLoungeList } from '../components/WDWLoungeList';
import debounce from 'lodash.debounce';
import {
  ENABLE_DEFERRED_AUX_FETCHES,
  ENABLE_IO_SCROLL,
  ENABLE_PROGRESSIVE_SLICE,
} from '../constants/features';

type FormData = {
  chat_msg: string;
};

type SearchData = {
  searchValue: string;
};

const WdwLandLounge = () => {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();

  const { search } = useParams();

  const { status, sortByTime, stickyItem } = useSelector(selectLounges);
  const stickyPosts = asArray(stickyItem);
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();
  const [shortByTime, setShortByTime] = useState<any | string>(
    localStorage.getItem('shortByTime')
  );

  const [showPopup, setShowPopup] = useState<any | string>(true);
  const [isLoading, setIsLoading] = useState<any | string>(false);

  let subtitle: any;

  let sortType: any = null;
  let LoungeId: any = null;
  let searchValue: any = null;

  const [currentPage, setCurrentPage] = useState(1);
  const [myData, setMyData] = useState<any[]>([]);
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(true);
  const isFetchingRef = useRef(false);
  const hasMoreRef = useRef(true);
  const lastKeyRef = useRef<string | undefined>();
  const DEFAULT_VISIBLE = 20;
  const VISIBLE_INCREMENT = 10;
  const [visibleCount, setVisibleCount] = useState(() =>
    ENABLE_PROGRESSIVE_SLICE ? DEFAULT_VISIBLE : Number.MAX_SAFE_INTEGER
  );

  useEffect(() => {
    sortByTime != '' && setShortByTime(sortByTime);
  }, [sortByTime]);

  // LoungeBox / edit menus read rights from localStorage during render.
  // Refresh on WDW too so a user-switch cannot keep leftover editor=true.
  const loginuserid = localStorage.getItem('user_id');
  const [, setMenuFlagsRevision] = useState(0);
  useEffect(() => {
    syncAssignMenuFlagsToCurrentUser();
    setMenuFlagsRevision((revision) => revision + 1);
    if (!loginuserid) {
      applyAssignMenuFlags([]);
      return;
    }
    dispatch(fetchUserMenu({ loginuserid }))
      .then((res: any) => {
        applyAssignMenuFlags(res?.payload);
        setMenuFlagsRevision((revision) => revision + 1);
      })
      .catch(() => {
        applyAssignMenuFlags([]);
        setMenuFlagsRevision((revision) => revision + 1);
      });
  }, [dispatch, loginuserid]);

  const handleLoginClick = () => {
    setShowPopup(!showPopup);
  };

  useEffect(() => {
    isFetchingRef.current = isFetching;
  }, [isFetching]);

  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);

  useEffect(() => {
    if (!ENABLE_IO_SCROLL) {
      return;
    }
    if (typeof IntersectionObserver === 'undefined') {
      return;
    }

    const sentinel = sentinelRef.current;
    if (!sentinel) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && hasMoreRef.current && !isFetchingRef.current) {
            isFetchingRef.current = true;
            setIsFetching(true);
            setCurrentPage((prev) => prev + 1);
          }
        });
      },
      { rootMargin: '200px' }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, []);

  const loadDataOnlyOnce = () => {
    if (currentPage === 1) {
      window.scrollTo(0, 0);
    }
    loadProgressBar();

    if (!search) {
      if (currentPage === 1) {
        const runStickyFetch = () => {
          dispatch(fetchStickyLoungeWdw({}));
        };

        if (ENABLE_DEFERRED_AUX_FETCHES && typeof window !== 'undefined') {
          const idle = (window as any).requestIdleCallback;
          if (typeof idle === 'function') {
            idle(() => runStickyFetch());
          } else {
            window.setTimeout(runStickyFetch, 150);
          }
        } else {
          runStickyFetch();
        }
      }
    } else {
      searchValue = search;
    }

    isFetchingRef.current = true;
    setIsFetching(true);

    dispatch(
      fetchDisneyWorldLounges({
        sortType,
        LoungeId,
        currentPage,
        searchValue,
        shortByTime,
      })
    )
      .then((res: any) => {
        if (!isFulfilledFeedAction(res)) {
          return;
        }

        const posts = Array.isArray(res?.payload) ? res.payload : [];

        let nextData: any[] = [];
        setMyData((prev: any[]) => {
          if (currentPage === 1) {
            nextData = posts;
            return posts;
          }
          if (!posts.length) {
            nextData = prev;
            return prev;
          }
          const seen = new Set(prev.map((p: any) => p.chat_id));
          const filtered = posts.filter((p: any) => !seen.has(p.chat_id));
          nextData = filtered.length ? [...prev, ...filtered] : prev;
          return nextData;
        });

        if (ENABLE_PROGRESSIVE_SLICE) {
          const postsLength = posts.length;
          if (currentPage === 1) {
            const initialVisible = postsLength
              ? Math.min(DEFAULT_VISIBLE, postsLength)
              : DEFAULT_VISIBLE;
            setVisibleCount(initialVisible);
          } else if (postsLength > 0) {
            setVisibleCount((prevVisible) => {
              const increment = Math.max(postsLength, VISIBLE_INCREMENT);
              return Math.min(nextData.length, prevVisible + increment);
            });
          }
        }

        const hasNext = posts.length > 0;
        setHasMore(hasNext);
        hasMoreRef.current = hasNext;
      })
      .catch((err: any) => {
        console.error('fetchDisneyWorldLounges failed', err);
      })
      .finally(() => {
        isFetchingRef.current = false;
        setIsFetching(false);
      });
  };

  useEffect(() => {
    const key = JSON.stringify({ search: search || null, shortByTime: shortByTime || '' });
    if (lastKeyRef.current !== key) {
      lastKeyRef.current = key;
      setMyData([]);
      setHasMore(true);
      hasMoreRef.current = true;
      isFetchingRef.current = true;
      setIsFetching(true);
      if (ENABLE_PROGRESSIVE_SLICE) {
        setVisibleCount(DEFAULT_VISIBLE);
      }
      if (currentPage !== 1) {
        setCurrentPage(1);
        return;
      }
    }
    loadDataOnlyOnce();
  }, [shortByTime, search, currentPage]);

  const handleScroll = useCallback(() => {
    if (ENABLE_IO_SCROLL) {
      return;
    }

    if (
      window.innerHeight + document.documentElement.scrollTop + 1 >=
      document.documentElement.scrollHeight
    ) {
      if (!hasMoreRef.current || isFetchingRef.current) {
        return;
      }
      isFetchingRef.current = true;
      setIsFetching(true);
      setCurrentPage((prev) => prev + 1);
    }
  }, []);

  useEffect(() => {
    if (ENABLE_IO_SCROLL) {
      return;
    }
    const debounced = debounce(handleScroll, 200);
    window.addEventListener('scroll', debounced);
    return () => {
      debounced.cancel();
      window.removeEventListener('scroll', debounced);
    };
  }, [handleScroll]);

  const hasFetchedPosts = myData.length > 0;
  const isInitialLoading = shouldShowFeedInitialLoading(
    status,
    hasFetchedPosts,
    isFetching
  );
  const showFeedLoadError = shouldShowFeedLoadError(status, hasFetchedPosts);
  const postsToRender = ENABLE_PROGRESSIVE_SLICE
    ? myData.slice(0, visibleCount)
    : myData;
  const hasPosts = postsToRender.length > 0;
  const showPagingSpinner = isFetching && hasMore && hasFetchedPosts;

  return (
    <>
    
      <Helmet>
        <title>MouseWait Disneyworld Lounge</title>
        <meta property='og:title' content='Mousewait' />
        <meta
          property='og:image'
          content='https://mousewait.com/static/media/MouseWait-img.fed12113160621608cfe.png'
        />
        <meta
          property='og:description'
          content='MouseWait provides a wealth of information for both casual and frequent visitors to the Disneyland Resort. It does exactly what it claims and more, and it does it extremely well. '
        />
      </Helmet>

      <div className='mid-main'>
        <div className='container'>
          <div className='mid-sec'>
            <LoungeHeader />
            <MobileLoungeHeader />
            <div className='mid-card-sec'>
              {showFeedLoadError ? (
                <div className='content__error-info'>
                  <h2>Error</h2>
                  <p>Please try to open the page later.</p>
                </div>
              ) : (
                <div className='content__items'>
                  <div>
                    <LoungeBox
                      setVisible={() => {}}
                      isVisible={false}
                      onCloseMenu={() => {}}
                    />
                  </div>
                  <PendingPostNotice />

                  {isInitialLoading ? (
                    [...new Array(5)]?.map((_, index) => (
                      <Placeholder key={index} />
                    ))
                  ) : stickyPosts[0] != null ? (
                    <StickyPost
                      key={stickyPosts[0]?.chat_id ?? 'sticky'}
                      obj={stickyPosts[0]}
                      mybutton={true}
                    />
                  ) : (
                    ''
                  )}

                  {hasPosts ? (
                    postsToRender.map((e) =>
                      e.checksticky === null ? (
                        <WDWLoungeList key={e.chat_id} obj={e} />
                      ) : null
                    )
                  ) : (
                    !isInitialLoading && (
                      <div className='no-posts-message'>
                        <p>No posts available yet.</p>
                      </div>
                    )
                  )}

                  <div
                    className='infinite-scroll-loader'
                    role='status'
                    aria-live='polite'
                    aria-busy={showPagingSpinner ? 'true' : 'false'}
                    style={{ textAlign: 'center', padding: '12px 0' }}
                    ref={ENABLE_IO_SCROLL ? sentinelRef : null}
                  >
                    {showPagingSpinner && (
                      <>
                        <span className='infinite-scroll-loader__spinner' />
                        <span className='loader-visually-hidden'>Loading more posts…</span>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WdwLandLounge;
